import React from 'react';
import ReactPlayer from 'react-player';

const Scenario5Video = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/-ikIuidHH0k' controls={true} />
        </div>
    );
}

export default Scenario5Video;